var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"pa-0 d-duplication-divider"},[_c('v-divider'),_c('v-divider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }